module.exports = __webpack_public_path__ + "static/media/back@2x.93a032a0.png";